var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "forgot-password-container" }, [
    _c("div", { staticClass: "forgot-password-title" }, [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.returnToSignIn()
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("@/common/assets/images/icon-left.webp"),
              alt: "back"
            }
          })
        ]
      ),
      _c("h2", [_vm._v("Forgot Password")])
    ]),
    _c(
      "form",
      {
        staticClass: "forgot-password-form",
        on: { submit: event => _vm.handleSubmit(event) }
      },
      [
        _c("span", { staticClass: "forgot-password-info" }, [
          _vm._v(
            " Enter the email address associated with your account and we will send you a new password "
          )
        ]),
        _c("div", { staticClass: "forgot-password-form-content" }, [
          _c("label", { attrs: { for: "email" } }, [_vm._v("Email:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.username,
                expression: "formData.username"
              }
            ],
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("username") }
            ],
            attrs: {
              type: "email",
              id: "email",
              name: "email",
              placeholder: "Enter your email",
              autocomplete: "email",
              required: ""
            },
            domProps: { value: _vm.formData.username },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("username")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "username", $event.target.value)
              }
            }
          })
        ]),
        _c(
          "div",
          { staticClass: "form-bottom" },
          [
            _vm._l(_vm.FORM_VALIDATOR?.errors(), function(error, index) {
              return _c("span", { key: index, staticClass: "error" }, [
                _vm._v(_vm._s(error.fieldCondition.message) + " ")
              ])
            }),
            _c("input", {
              class: [
                "forgot-password-button",
                {
                  "not-allowed":
                    !_vm.FORM_VALIDATOR?.isFormValid() || !_vm.formData.username
                }
              ],
              attrs: { type: "submit", value: "CONTINUE" }
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }